// extracted by mini-css-extract-plugin
module.exports = {"rotate":"reset-button_rotate__3v2bj"};